import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import CreateAbandonmentPage from "./CreateAbandonmentForm";
import EditAbandonmentPage from "./EditAbandonmentForm";


export const AbandonmentModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
        <ProtectedRoute exact path={path}>
              <CreateAbandonmentPage />
        </ProtectedRoute> 
        <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
              <EditAbandonmentPage />
        </ProtectedRoute>
       
      </Switch>
    
  );
};

export default AbandonmentModule;
